import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class SharingVendorText extends PrimitiveValueObject<string> {
  static create(value: string): SharingVendorText {
    return new SharingVendorText(value);
  }
}
